import React from 'react'
import { createStore, createHook, defaults } from 'react-sweet-state'
defaults.devtools = true

const Store = createStore({
    initialState: {
        stream: null,
        video: false,
        audio: false,
        loading: false,
        connections: 0
    },
    actions: {
        init: ({audioOnly = false}) => async({setState, getState}) => {
            if(getState().loading === true) return;

            const current = getState().stream
            if(current && (audioOnly || getState().video)){
                setState({
                    connections: getState().connections + 1
                })
                return
            }

            setState({loading: true})
            const constraints = {audio: true, video: !audioOnly}
            const stream = await navigator.mediaDevices.getUserMedia(constraints)
            setState({
                loading: false,
                stream,
                audio: true,
                video: !audioOnly,
                connections: getState().connections + 1
            })
        },
        close: () => ({setState, getState}) => {
            if(getState().connections - 1 === 0){
                const stream = getState().stream
                const tracks = stream.getTracks()

                tracks.forEach(track => track.stop())
                setState({
                    stream: null,
                    audio: false,
                    video: false
                })
            }

            setState({
                connections: getState().connections - 1
            })
        }
    },
    name: 'media_context'
})

export const useMedia = createHook(Store)
